import { Alert, Button, Form } from 'react-bootstrap';
import { MdInfo } from 'react-icons/md';
import styled from 'styled-components';

export const FormLabelCustom = styled(Form.Label)`
  &:after {
    color: ${({ theme }) => theme.colors.error};
    content: ' *';
    display: ${({ required }) => (required ? 'inline' : 'none')};
  }
`;

export const ButtonHeader = styled(Button)`
  margin: 10px 0px;
`;

export const CustomAlert = styled(Alert)`
  display: flex;
  gap: 4px;
  align-items: center;
  margin: 0 5px;
`

export const InfoIcon = styled(MdInfo)`
  color: #0e86fe;
  font-size: 32px;
`;